import exp from "constants";
import styled from "styled-components";
export const Container = styled.label`
    
`;

export const SectionOne = styled.section`
    grid-template-columns: 20em 1fr;
    min-height: 100vh;
    width: 100%;
    display: flex;
    background: linear-gradient(rgba(0, 0, 0, 0.44 ), rgba(0, 0, 0, 0.9)), url('./images/HeroImage.png') no-repeat center / cover;
    color: var(--thirdBlue);
    @media (max-width: 768px){
        flex-wrap: wrap;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
    }
`;

export const SectionTwo = styled.section`
    min-height: 100vh;
    width: 100%;
    display: flex;  
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
`;

export const MainImage = styled.img`
    
`;

export const ContactSection = styled.div`
    padding: 10rem;
    min-height: 95vh;
    width: 100%;
    background: linear-gradient(rgba(0, 0, 10, 0.87 ), rgba(0, 0, 0, 0.9)), url('./images/contactBackground.jpg') no-repeat center / cover;
    justify-self: center;
    text-align: center;
    display:flex;
    flex-direction:column;
    align-items:center;
`;

export const ContactTitle = styled.h1`
    font-size: 3rem;
    padding: 2rem;
    color: var(--thirdBlue);
    @media(max-width:768px){
        padding: 0;
        font-size: 2rem;
        margin-bottom: 1rem;
    }
`;

export const ContactCards = styled.div`
    background-color: var(--secondBlue);
    box-shadow: 0px 0px 15px -5px var(--mainShadow);
    margin: 0 10px;
    width: 20rem;
    height: 9rem;
    display: flex;
    flex-direction:column;
    justify-content: center;
    margin-bottom: 3rem;
    cursor: pointer;
    transition: 0.3s;
    &:hover{
        transform: scale(1.1);
        box-shadow: 0px 0px 30px -5px var(--mainShadow);
    }
`;

export const ContactLinks = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size:2rem;
    padding: 1rem;
    letter-spacing: 2px;
`;

export const ContactLogos = styled.img`
    width:48px;
    margin-right: 0.5rem;
`;

export const HeroImgTitlle = styled.div`
    width: 90%;
    height: 100%;
    max-width: 1200px;
    display: flex;
    flex-direction: column;
    align-items:center;
    padding: 5rem;
    justify-content: center;
    position: relative;
    margin: 0 auto; 
    font-size: 5rem;
    text-align: center;
    @media (max-width: 768px){
        font-size: 2rem;
        margin-bottom: 1rem;
    }
`;

export const ContactButton = styled.a`
    cursor: pointer;
    display: inline-block;
    border-radius:4px;
    padding: 0.5em 2em;
    color: black;
    background: var(--thirdBlue);
    transition: 0.3s;
    font-size: 3rem;
    margin-bottom: 5rem;
    &:hover{
        background: var(--secondBlue);
        transform: scale(1.2);
        box-shadow: 0px 0px 40px -3px var(--secondShadow);
        color: white;
  }
`;

export const IntroductionArrow = styled.a`
    cursor: pointer;
    border: solid var(--mainBlue);
    height: 10px;
    width: 10px;
    border-width: 0 0.5rem 0.5rem 0;
    padding: 0.7rem;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    transition: 0.3s;
    &:hover{
        scale: 1.3;
    }
`;

export const IntroductionDetails = styled.p`    
    color: var(--mainBlue);
    margin-bottom: 5rem; 
`;

export const MainDetailsSection = styled.div`
    display: flex;
    text-align: center;
    padding: 5rem;
    flex-wrap: wrap;
    border-radius: 5px;
    color: var(--thirdBlue);
    @media (max-width: 768px){
        grid-template-columns: 20rem;
        padding: 1rem;
    }
`;

export const MainDetailsTitle = styled.h1`
    font-size: 3rem;
    padding: 0.5rem;
    margin: 0 auto;
    margin-top: 2rem;
    margin-bottom: 2rem;
    align-self:center;
    @media (max-width: 768px){
        font-size: 2.5rem;
        
    }
    @media (max-width: 1080px){
        font-size: 2.7rem;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const MainDetailsText = styled.p`
    padding: 0.5rem;
    justify-self: center;
    margin-bottom: 2rem;
    font-size: 2rem;
    overflow-x: hidden;
    background: var(--secondBlue);
    color: white;
    box-shadow: 0px 0px 30px -5px var(--secondShadow);
    @media (max-width: 768px){
        font-size: 1.5rem;
        max-height: 10em;
        overflow-y: scroll;
        margin-bottom: 1rem;
    }
`;

//second part
export const MainTitle = styled.div`
    display: flex;
    flex-direction: column;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: var(--thirdBlue);
    @media (max-width: 768px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const FirstTitle = styled.h1`
    padding: 0.5rem;
    justify-self: center;
    margin-bottom: 2rem;
    text-align: center;
    font-size: 3rem;
    @media (max-width: 768px){
        font-size: 2.7rem;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        font-size: 2.7rem;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const Logos = styled.section`
    display:flex;
    object-fit: cover;
    margin-bottom: 2rem;
    @media (max-width: 768px){
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`

export const UnifespLogo = styled.img`
    width: 15em;
    @media (max-width: 768px){
        width: 7rem;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const InstitutoLogo = styled.img`
    margin-left: 5rem;
    width: 15em;
    @media (max-width: 768px){
        width: 7rem;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const SecondTitle = styled.h1`
    margin-bottom: 2rem;
    padding: 0.5rem;
    justify-self: center;
    text-align: center;
    font-size: 3rem;
    @media (max-width: 768px){
        font-size: 2.7rem;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        font-size: 2.7rem;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const CarouselGroup1 = styled.div`
    max-width: 100%;
    justify-self: center;
    @media (max-width: 768px){
        max-width: 100%;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const CarouselBar1 = styled.div`
    display:flex;
    flex-wrap:wrap; 
    max-width:1800px;
    justify-content: center;
    margin-bottom: 2rem;
    /* justify-self: center;
    display: flex;
    overflow: scroll;
    overflow-y: hidden; */
`;

export const ThirdTitle = styled.h1`
    margin-bottom: 2rem;
    padding: 0.5rem;
    justify-self: center;
    font-size: 3rem;
    @media (max-width: 768px){
        font-size: 2.5rem;
        margin-bottom: 1rem;
    }
    @media (max-width: 1080px){
        font-size: 2.7rem;
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;

export const CarouselGroup2 = styled.div`
    max-width: 100%;
    justify-self: center;
    @media (max-width: 768px){
        max-width: 100%;
    }
    @media (max-width: 1080px){
        flex-wrap: wrap;
        margin-bottom: 1rem;
    }
`;
export const CarouselBar2 = styled.div`
    display:flex;
    flex-wrap:wrap; 
    max-width:1800px;
    justify-content: center;
    /* justify-self: center;
    display: flex;
    overflow: scroll;
    overflow-y: hidden; */
`;